module.exports = __webpack_public_path__ + "img/wt@2x.19aa98f1.png";